import { Navigate, Route } from 'react-router-dom';
import { CustomerProcessStatusEnum, OpenType } from 'types/customer';
import { GetRouteParams } from 'types/open';
import Confirm from '../components/Confirm';
import Invest from '../components/Invest';
import Job from '../components/Job';
import QualificationQuestionnaire from '../components/QualificationQuestionnaire';
import TrustedContact from '../components/TrustedContact';
import Address from './Address';
import Agreements from './Agreements';
import BaseInfo from './BaseInfo';
import BaseInfo2 from './BaseInfo2';
import Beneficiary from './Beneficiary';
import Complete from './Complete';
import Revenue from './Revenue';

export function getSSNRoutes({ currentProcessStatus, location, openType, defaultUploadPath }: GetRouteParams) {
    return (
        <>
            {currentProcessStatus === CustomerProcessStatusEnum.UNACCOUNT && (
                <>
                    <Route path="baseinfo" element={<BaseInfo />} />
                    <Route path="baseinfo2" element={<BaseInfo2 />} />
                    <Route path="address" element={<Address />} />
                    <Route path="job" element={<Job />} />
                    <Route path="trusted-contact" element={<TrustedContact isSSN />} />
                    <Route path="qualification-questionnaire" element={<QualificationQuestionnaire />} />
                    <Route path="invest" element={<Invest isSSN />} />
                    <Route path="beneficiary" element={<Beneficiary />} />
                    <Route path="revenue" element={<Revenue />} />
                    <Route path="agreements" element={<Agreements />} />
                    <Route
                        path="*"
                        element={
                            <Navigate
                                to={{
                                    ...location,
                                    pathname: openType === OpenType.IRA ? 'baseinfo' : 'category'
                                }}
                                state={location.state}
                                replace
                            />
                        }
                    />
                </>
            )}
            {currentProcessStatus === CustomerProcessStatusEnum.CONTINUE && (
                <>
                    {/* 大客户开户资料确认页 */}
                    <Route path="confirm/*" element={<Confirm />} />
                    <Route
                        path="*"
                        element={
                            <Navigate
                                to={{
                                    ...location,
                                    // 如果没有具体的业务路由，默认跳转个人中心
                                    pathname: defaultUploadPath || '/profile'
                                }}
                                replace
                            />
                        }
                    />
                </>
            )}
            {currentProcessStatus === CustomerProcessStatusEnum.AUDITING && (
                <>
                    <Route path="complete" element={<Complete />} />
                    <Route path="*" element={<Navigate to={{ ...location, pathname: 'complete' }} replace />} />
                </>
            )}
            <Route
                path="*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/profile'
                        }}
                        replace
                    />
                }
            />
        </>
    );
}
